module.exports = __webpack_public_path__ + "img/amx-5.5fd0b007.jpg";